<template>
<div id="enterprise-list-wrapper">
  <mainHeader class="mainHeader"></mainHeader>
  <div class="wrapper">
    <!-- <van-search v-model="seacherValue" placeholder="请输入供应商关键字"   @search="onSearch"/> -->
    <div class="section section1">
      <div class="title">整合产业链优质资源</div>
      <div class="stitle">实现信息共享，发挥“互联网+”规模优势</div>
      <button class="setIn" v-on:click="setInClick">免费入驻</button>
    </div>
    <div class="section section2">
      <div class="items">
        <div class="item" v-for="(value,index) in enItems" :key="index" @click="gotoItemClick">
          <img :src="value.image" />
          <br />
          <span>{{value.title}}</span>
          <!-- <span>{{value.title}}</span> -->
        </div>
      </div>    
    </div>
    <!--金牌供应商-->
    <div class="section section3">
      <div class="title">金牌供应商</div>
      <div class="content">
        <div class="item" v-for="(value,index) in vipSupplierData" :key="index" @click="businessInfoClick(value.id)">
          <img class="vip" v-show="index < 3" :src="vipImages[index]" />
          <div class="number" v-show="index >= 3">{{index+1}}</div>
          <div class="image dimage" v-show="value.logo == null"></div>
              <div class="image" :style="{backgroundImage:'url('+imageUrl+value.logo+')'}" ></div>
              <div class="title">{{value.company_name}}</div>
              <!--<div class="code"></div>-->
        </div>
          </div>
    </div>
    <!--采购动态-->
    <div class="section section4">
      <div class="header">
        <span class="title">采购动态</span>
        <span class="stitle">买家求购，卖家快速报价</span>
      </div>
      <div class="content">
        <div class="items">
          <div class="item" v-for="(value,index) in buyData" :key="index" @click="buyInfoClick(value.id)">
            <div class="left">
              <div class="title">{{value.title}}</div>
              <div class="time">{{value.created_time}}</div>
              <div class="en-name">{{value.ent_name}}</div>
            </div>
            <div class="right">
              <div class="state">采购中</div>
              <div class="number"><img src="../assets/icon-enter-msg.png" />{{value.want_offer_num}}</div>
              <div class="finish">已报价</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--成交动态-->
    <div class="section section5">
      <div class="header"></div>
      <div class="finish">
        <swiper class="swiperFinish" :options="swiperOptionFinish" ref="swiperFinish">
        <!-- slides -->
            <swiper-slide class="list" v-for="(value,index) in finishedData" :key="index">
              <div class="box">
                <div class="title">{{value.title}}</div>
                <div class="stitle">{{value.stitle}}</div>
                <div class="state">已成交</div>
                <div class="time">{{value.time}}</div>
              </div>
            </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="section section6">
      <div class="title">推荐供应商</div>
      <div class="content">
        <div class="items">
          <div class="item" v-for="(value,index) in recSupplierData" :key="index" @click="businessInfoClick(value.id)">
            <div class="image dimage" v-show="value.logo == null"></div>
            <div class="image" :style="{backgroundImage:'url('+imageUrl+value.logo+')'}"></div>
            <div class="title">{{value.company_name}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--产业链-->
    <div class="section section7">
      <div class="header"></div>
      <div class="content">
        <div class="item" v-for="(value,index) in productData" :key="index">
          <div class="bg" :style="{backgroundImage:'url('+value.image+')'}" >
            <div class="line"></div>
            <div class="mark" v-html="value.mark"></div>
            <div class="title">{{value.title}}</div>
            <div class="stitle">{{value.stitle}}</div>
          </div>
          <div class="detail"><img src="../assets/icon-enter-next.png"/>{{index==0?"在线咨询":"查看详情"}}</div>
        </div>
      </div>
    </div>
    <!--行业资讯-->
    <div class="section section8">
      <div class="header">
        <span class="title">行业资讯</span>
        <span class="stitle">资讯、新闻行业热点</span>
        <div class="more" @click="gotoNewsList">更多 <img src="../assets/icon-next.png" /></div>
      </div>
      <div class="content">
        <div class="items">
          <div class="item" v-for="(value,index) in newsData" :key="index" @click="gotoNewsinfo(value.id)">
            <div class="image dimage" v-show="value.logo == null"></div>
            <div class="image" :style="{backgroundImage:'url('+imageUrl+value.thumbnail+')'}" ></div>
            <div class="title">{{value.title}}</div>
            <div class="time"><img src="../assets/icon-enter-time.png" />  {{value.created}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--榜单-->
    <div class="section section9">
      <div class="header">
        <div class="swiper-pagination-pattern" slot="pagination">
        </div>
      </div>
    </div>
    <div class="section section10">
      <swiper class="swiperPattern" :options="swiperOptionPattern" ref="swiperPattern">
        <!-- slides -->
          <swiper-slide class="slideList slideList1">
              <div class="slide slide1" v-for="(value,index) in patternData1" :key="index" @click="gotoNewsinfo(value.id)">
                <div class="box"></div>
                <div class="title">{{value.title}}</div>
              </div>
          </swiper-slide>
          <swiper-slide class="slideList slideList2">
              <div class="slide slide1" v-for="(value,index) in patternData2" :key="index" @click="gotoNewsinfo(value.id)">
                <div class="box"></div>
                <div class="title">{{value.title}}</div>
              </div>
          </swiper-slide>
          <swiper-slide class="slideList slideList3">
              <div class="slide slide1" v-for="(value,index) in patternData3" :key="index" @click="gotoNewsinfo(value.id)">
                <div class="box"></div>
                <div class="title">{{value.title}}</div>
              </div>
          </swiper-slide>

      </swiper>
    </div>

    <mainFooter class="mainFooter"></mainFooter>

  </div>
</div>

</template>

<script>
import mainHeader from '../view/header'
import mainFooter from '../view/footer'

export default{
  data () {
    return {
      imageUrl: this.utils.ResourceUrl,
      seacherValue : "",
      vipImages: [
        require('../assets/icon-enn-item1.png'),
        require('../assets/icon-enn-item2.png'),
        require('../assets/icon-enn-item3.png')
      ],
      enItems: [
        {'id': '1', 'title': '消防咨询', 'image': require('../assets/icon-enter-item1.png')},
        {'id': '2', 'title': '审图设计', 'image': require('../assets/icon-enter-item2.png')},
        {'id': '3', 'title': '消防产品', 'image': require('../assets/icon-enter-item3.png')},
        {'id': '4', 'title': '施工安装', 'image': require('../assets/icon-enter-item4.png')},
        {'id': '5', 'title': '智慧消防', 'image': require('../assets/icon-enter-item5.png')},
        {'id': '6', 'title': '维保服务', 'image': require('../assets/icon-enter-item6.png')},
        {'id': '7', 'title': '消防培训', 'image': require('../assets/icon-enter-item7.png')},
        {'id': '8', 'title': '应急救援', 'image': require('../assets/icon-enter-item8.png')}
      ],
      productData: [
        {'id': '1', 'mark': '咨<br/>询', 'title': '一键提问，及时为企业解答安全问题', 'stitle': '消防咨询、备案咨询、验收咨询一键提问专家回复，快 速了解，及时为企业解答消防安全问题', 'image': require('../assets/icon-ens-item1.png')},
        {'id': '2', 'mark': '管<br/>家', 'title': '为企业全方位火灾风险控制', 'stitle': '风险控制、建设规范、日常监控、风险转移', 'image': require('../assets/icon-ens-item2.png')},
        {'id': '3', 'mark': '绘<br/>审', 'title': '在线提交，快速获取审图建议', 'stitle': '流程指导、设计咨询、改造工程、过程监管、技术服务', 'image': require('../assets/icon-ens-item3.png')},
        {'id': '4', 'mark': '检<br/>测', 'title': '便捷操作，5步轻松获取检测报告', 'stitle': '行业建筑材料、国际检测机构、快速送检通道', 'image': require('../assets/icon-ens-item4.png')},
        {'id': '5', 'mark': '保<br/>障', 'title': '应急安全保障服务平台', 'stitle': '专业应急方案、专业救援装备、专业救援团队 不同场景定制“预防+人防+物防”的应急安全保障服务', 'image': require('../assets/icon-ens-item5.png')}
      ], // 产业链
      finishedData: [
        {'id': '1', 'title': '厂房改造部分工程采购', 'stitle': '无锡革新幕墙装饰工程有限公司', 'time': '05-06 10:57'},
        {'id': '2', 'title': '妇产科医院报价', 'stitle': '武汉大江智谷科技有限公司', 'time': '05-05 18:34'},
        {'id': '3', 'title': '妇产科医院报价', 'stitle': '沈阳港华装饰股份有限公司', 'time': '05-05 16:45'},
        {'id': '4', 'title': '火灾报警采购', 'stitle': '山西省宏博消防工程安装有限公司', 'time': '05-04 14:27'},
        {'id': '5', 'title': '柴油发电机房水喷雾', 'stitle': '无锡革新幕墙装饰工程有限公司', 'time': '05-04 11:16'},
        {'id': '6', 'title': '变电所气体灭火系统', 'stitle': '青岛千程安消防科技有限公司', 'time': '05-04 09:41'}
      ], // 成交
      vipSupplierData: [], // 金牌供应商
      recSupplierData: [], // 推荐供应商
      buyData: [],
      newsData: [],
      patternData1: [],
      patternData2: [],
      patternData3: [],
      swiperOptionFinish: {
        direction: 'vertical',
        effect: 'slide',
        loop: true,
        autoplay: true
      },
      swiperOptionPattern: {
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        pagination: {// 分页器
          el: '.swiper-pagination-pattern',
          clickable: true,
          renderBullet: function (index, className) {
            var titles = ['房地产百强', '百强榜单', '品牌价值榜单']
            return '<span class="' + className + '">' + titles[index] + '<span></span></span>'
          }
        },
        fadeeffect: true
      }
    }
  },
  watch: {
    $router () {
    }
  },
  methods: {
    onSearch(val){
      console.log(val);
    },
    gotoNewsList: function () {
      console.log('================')
      this.$router.push({path: 'news-list', query: {}})
    },
    gotoNewsinfo: function (id) {
      console.log('================')
      this.$router.push({path: 'news-info', query: {newsID: id}})
    },
    setInClick: function () { // 计入
      window.location.href = 'http://www.zxzx119.com/register'
    },
    gotoItemClick: function () { //
      window.location.href = 'http://www.zxzx119.com/ListEnterprises'
    },
    businessInfoClick: function (id) {
      window.location.href = 'http://www.zxzx119.com/listxq/' + id
    },
    buyInfoClick: function (id) {
      window.location.href = 'http://www.zxzx119.com/shoplist?id=' + id
    },
    loadData: function () {
      var _this = this

      // 金牌供应商 http://www.zxzx119.com/account/supplier/list?gold=1
      this.utils.GET(this.accountUrl + '/supplier/list?gold=1',
        function (data) {
          _this.vipSupplierData = data.data.rows
        })

      // 推荐供应商 http://www.zxzx119.com/account/supplier/list?type=2,13,14,15&index=1
      this.utils.GET(this.accountUrl + '/supplier/list?type=2,13,14,15&index=1',
        function (data) {
          _this.recSupplierData = data.data.rows
        })

      // 采购动态 http://www.zxzx119.com/account/wantBuy/wantBuyList?page=1&rows=8
      this.utils.GET(this.accountUrl + '/wantBuy/wantBuyList?page=1&rows=8',
        function (data) {
          _this.buyData = data.data.rows
        })
      // 行业资讯 http://www.zxzx119.com/account/jpressContent/list?pageNo=1&pageSize=8&taxonomyIds=66
      this.utils.GET(this.accountUrl + '/jpressContent/list?pageNo=1&pageSize=8&taxonomyIds=66',
        function (data) {
          _this.newsData = data.data.rows
        })
      // 房地产百强 http://www.zxzx119.com/account/jpressContent/list?pageNo=1&pageSize=10&taxonomyIds=67
      // 百强榜单 http://www.zxzx119.com/account/jpressContent/list?pageNo=1&pageSize=10&taxonomyIds=68
      // 品牌价值榜单 http://www.zxzx119.com/account/jpressContent/list?pageNo=1&pageSize=10&taxonomyIds=69
      this.utils.GET(this.accountUrl + '/jpressContent/list?pageNo=1&pageSize=8&taxonomyIds=67',
        function (data) {
          _this.patternData1 = data.data.rows
        })
      this.utils.GET(this.accountUrl + '/jpressContent/list?pageNo=1&pageSize=8&taxonomyIds=68',
        function (data) {
          _this.patternData2 = data.data.rows
        })
      this.utils.GET(this.accountUrl + '/jpressContent/list?pageNo=1&pageSize=8&taxonomyIds=69',
        function (data) {
          _this.patternData3 = data.data.rows
        })
    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>

.mainHeader{
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper{
  background-color: #F6F6F6;
  width: 100%;
  /*margin-bottom: 70px;*/
  margin-top: 55px;
}
.section{
  position: relative;
  /*border-bottom: yellow solid 1px;
  box-sizing: border-box;*/
}
.section3,.section4,.section5,.section6,.section7,.section8{
  margin-bottom: 10px;
}
.section1{
  height: 170px;
  background-image: url(../assets/icon-enter-top.jpg);
  background-size: cover;
  background-position: center center;
}
.section1 .title{
  position: absolute;
  top: 40px;
  width: 100%;
  height: 25px;
  font-size: 19px;
  color: #FFFFFF;
  font-weight: bold;
  text-align: center;
}
.section1 .stitle{
  position: absolute;
  top: 70px;
  width: 100%;
  height: 20px;
  font-size: 13px;
  color: #e5e5e5;
  text-align: center;
}
.section1 .setIn{
  position: absolute;
  top: 110px;
  left: calc(50% - 45px);
  width: 90px;
  height: 25px;
  line-height: 25px;
  font-size: 13px;
  color: #FFFFFF;
  text-align: center;
  background-color: #C41335;
  border-radius: 13px;
  text-align: center;

}
.section2{
  height: 200px;
}
.section2 .items{
  position: absolute;
  margin-top: 10px;
}
.section2 .items .item{
  float: left;
  width: calc((100% - 45px)/4);
  height: 83px;
  text-align: center;
  margin-left: 5px;
  margin-top: 5px;
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0px 4px 4px rgba(0,0,0,0.1);
}
.section2 .items .item:nth-child(1){
  margin-left: 15px;
}
.section2 .items .item:nth-child(5){
  margin-left: 15px;
}

.section2 .items .item img{
  margin-top: 15px;
  width: 30px;
  height: 30px;
}
.section2 .items .item span{
  color: #000000;
  font-size: 13px;
}
.section3{
  height: 370px;
  background-color: #FFFFFF;
}
.section3 .title{
  position: absolute;
  top: 0px;
  left: 15px;
  height: 45px;
  line-height: 45px;
  font-size: 17px;
  color: #000000;
  font-weight: bold;
}
.section3 .content{
  position: absolute;
  top: 45px;
  /*left: 15px;*/
  width: 100%;
  height: 325px;
  overflow: hidden;
}
.section3 .content .item{
  position: relative;
  width: 100%;
  height: 65px;
  border-bottom: solid #EEEEEE 1px;
  box-sizing: border-box;
}
.section3 .content .item .vip{
  position: absolute;
  left: 18px;
  top: 18px;
  width: 24px;
  height: 29px;
}
.section3 .content .item .number{
  position: absolute;
  left: 20px;
  top: 22px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-color: #EEEEEE;
  border: solid #999999 1px;
  box-sizing: border-box;
  border-radius: 10px;
  color: #999999;
  font-size: 13px;
  text-align: center;
}
.section3 .content .item .image{
  position: absolute;
  left: 55px;
  top: 15px;
  width: 35px;
  height: 35px;
  background-image: url(../assets/icon_new_default.png);
  background-size: cover;
  background-position: center center;
  border: #EEEEEE solid 1px;
  box-sizing: border-box;
}
.section3 .content .item .title{
  position: absolute;
  left: 102px;
  right: 50px;
  top: 15px;
  bottom: 15px;
  height: 35px;
  line-height: 18px;
  font-size: 13px;
  color: #000000;
  /*vertical-align: middle;*/
}
.section3 .content .item .code{
  position: absolute;
  right: 15px;
  top: 22px;
  width: 20px;
  height: 20px;
  background-image: url(../assets/icon-enter-code.png);
  background-size: cover;
  background-position: center center;
}

.section4{
  height: 210px;
  background-color: #FFFFFF;
}
.section4 .header{
  position: absolute;
  top: 0px;
  left: 15px;
  height: 45px;
  line-height: 45px;
}
.section4 .header .title{
  font-size: 17px;
  font-weight: bold;
  color: #000000;
}
.section4 .header .stitle{
  margin-left: 5px;
  font-size: 13px;
  color: #999999;
}
.section4 .content{
  position: absolute;
  top: 45px;
  height: 160px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}
.section4 .content .items{
  height: 200px;
  width: 1045px;
}
.section4 .content .items .item{
  position: relative;
  float: left;
  width: 250px;
  height: 72px;
  margin-left: 5px;
  margin-top: 5px;
  background-color: #f8f8f8;
  border: solid #EEEEEE 1px;
  box-sizing: border-box;
}
.section4 .content .items .item:nth-child(1){
  margin-left: 15px;
}
.section4 .content .items .item:nth-child(5){
  margin-left: 15px;
}
.section4 .content .items .item .left{
  position: absolute;
  top: 0px;
  left: 10px;
  right: 70px;
  height: 72px;
}
.section4 .content .items .item .left .title{
  position: absolute;
  top: 7px;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #000000;
  font-weight: bold;
  word-wrap:break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.section4 .content .items .item .left .time{
  position: absolute;
  top: 27px;
  height: 20px;
  line-height: 20px;
  font-size: 11px;
  color: #999999;
}
.section4 .content .items .item .left .en-name{
  position: absolute;
  top: 47px;
  height: 20px;
  line-height: 20px;
  font-size: 11px;
  color: #999999;
}
.section4 .content .items .item .right{
  position: absolute;
  top: 0px;
  right: 10px;
  height: 72px;
  width: 50px;
  /*background-color: yellowgreen;*/
}
.section4 .content .items .item .right .state{
  position: absolute;
  right: 0px;
  width: 46px;
  top: 7px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 11px;
  color: #FFFFFF;
  font-weight: bold;
  background-color: #C41335;
}
.section4 .content .items .item .right .number{
  position: absolute;
  width: 50px;
  top: 27px;
  height: 20px;
  line-height: 20px;
  text-align: right;
  font-size: 11px;
  color: #C41335;
}
.section4 .content .items .item .right .number img{
  width: 9px;
  right: 9px;
  margin-top: 8px;
  margin-right: 5px;
}

.section4 .content .items .item .right .finish{
  position: absolute;
  width: 50px;
  top: 47px;
  height: 20px;
  line-height: 20px;
  text-align: right;
  font-size: 11px;
  color: #999999;
}
.section5{
  height: 60px;
  background-color: #FFFFFF;
}
.section5 .header{
  position: absolute;
  top: 22px;
  left: 15px;
  height: 15.5px;
  width: 81.5px;
  background-image: url(../assets/icon-enter-new.png);
  background-size: cover;
  background-position: center center;
}
.section5 .finish{
  position: absolute;
  top: 10px;
  left: 110px;
  right: 15px;
  height: 40px;
}
.section5 .finish .swiperFinish{
  position: relative;
  height: 40px;
}
.section5 .finish .swiperFinish .list .box{
  position: relative;
  /*height: 40px;
  background-color: greenyellow;*/
}
.section5 .finish .swiperFinish .box .title{
  position: absolute;
  top: 0px;
  left: 0px;
  right: 80px;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #323232;
  font-weight: bold;

  white-space: nowrap;
   overflow: hidden;
      text-overflow: ellipsis;
}
.section5 .finish .swiperFinish .box .stitle{
  position: absolute;
  top: 25px;
  left: 0px;
  right: 80px;
  height: 15px;
  line-height: 15px;
  font-size: 11px;
  color: #999999;

  white-space: nowrap;
  overflow: hidden;
      text-overflow: ellipsis;
}
.section5 .finish .swiperFinish .state{
  position: absolute;
  right: 0px;
  height: 20px;
  line-height: 20px;
  font-size: 11px;
  color: #C41335;
  font-weight: bold;
}
.section5 .finish .swiperFinish .time{
  position: absolute;
  top: 25px;
  right: 0px;
  height: 15px;
  line-height: 15px;
  font-size: 11px;
  color: #999999;

}

.section6{
  height: 100px;
  background-color: #FFFFFF;
}
.section6 .title{
  position: absolute;
  top: 0px;
  left: 15px;
  height: 45px;
  line-height: 45px;
  font-size: 17px;
  font-weight: bold;
  color: #000000;
}
.section6 .content{
  position: absolute;
  top: 40px;
  height: 55px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}
.section6 .content .items{
  height: 55px;
  width: 1100px;
}
.section6 .content .items .item{
  position: relative;
  float: left;
  width: 170px;
  height: 55px;
  margin-left: 10px;
  /*border: solid yellowgreen 1px;
  box-sizing: border-box;*/
}
.section6 .content .items .item:first-of-type{
  margin-left: 15px;
}
.section6 .content .items .item .image{
  margin-top: 10px;
  height: 35px;
  width: 35px;
  background-size: cover;
  background-position: center center;
  border: #EEEEEE solid 1px;
  box-sizing: border-box;
}
.section6 .content .items .item .title{
  margin-left: 30px;
  margin-top: 10px;
  height: 35px;
  line-height: 17px;
  font-size: 13px;
  color: #808080;
}
.section7{
  height: 730px;
  background-color: #0E162E;
  /*background-color: darkcyan;*/
}
.section7 .header{
  position: absolute;
  top: 22px;
  left: 15px;
  right: 15px;
  height: 53px;
  background-image: url(../assets/icon-ens-item-top.png);
  background-size: cover;
  background-position: center center;
}
.section7 .content{
  position: absolute;
  top: 75px;
  /*left: 15px;*/
  width: 100%;
  height: 655px;
  overflow: hidden;
}
.section7 .content .item{
  position: relative;
  margin-top: 15px;
  margin-left: 15px;
  margin-right: 15px;
  height: 116px;
  color: #FFFFFF;
  background-color: #22356C;
}
.section7 .content .item:first-of-type{
  margin-top: 0px;
}
.section7 .content .item .bg{
  position: relative;
  width: 100%;
  height: 80px;
  background-size: cover;
  background-position: center center;
}
.section7 .content .item .line{
  position: absolute;
  width: 1px;
  height: 64px;
  top: 8px;
  left: 39px;
  background-image: url(../assets/icon-en-line.png);
  background-size: cover;
  background-position: center center;
}
.section7 .content .item .mark{
  position: absolute;
  left: 10px;
  top: 10px;
  width: 40px;
  font-size: 19px;
  font-weight: bold;
}
.section7 .content .item .title{
  position: absolute;
  top: 15px;
  left: 53px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 600;
}
.section7 .content .item .stitle{
  position: absolute;
  top: 40px;
  left: 53px;
  right: 15px;
  height: 20px;
  line-height: 15px;
  font-size: 12px;
}
.section7 .content .item .detail{
  position: absolute;
  top: 80px;
  right: 15px;
  height: 35px;
  line-height: 35px;
  font-size: 13px;
}
.section7 .content .item .detail img{
  width: 10px;
  height: 8px;
  margin-right: 5px;
}
.section8{
  height: 230px;
  background-color: #FFFFFF;
}
.section8 .header{
  position: absolute;
  top: 0px;
  left: 15px;
  height: 45px;
  line-height: 45px;
  right: 15px;
}
.section8 .header .title{
  font-size: 17px;
  font-weight: bold;
  color: #000000;
}
.section8 .header .stitle{
  margin-left: 5px;
  font-size: 13px;
  color: #999999;
}
.section8 .header .more{
  position: absolute;
  top: 0px;
  right: 0px;
  height: 45px;
  line-height: 45px;
  font-size: 12px;
  color: #999999;
}
.section8 .header .more img{
  width: 6px;
  height: 10px;
}
.section8 .content{
  position: absolute;
  top: 50px;
  height: 160px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}
.section8 .content .items{
  height: 200px;
  width: 1045px;
}
.section8 .content .items .item{
  position: relative;
  float: left;
  width: 280px;
  height: 72px;
  margin-left: 15px;
  margin-bottom: 15px;

  /*background-color: #f8f8f8;
  border: solid #EEEEEE 1px;
  box-sizing: border-box;*/
}
.section8 .content .items .item .image{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 116px;
  height: 72px;
  /*background-color: #F9F9F9;*/
  background-size: cover;
  background-position: center center;
}

.dimage{
  background-image: url(../assets/icon_new_default.png);
}
.section8 .content .items .item .title{
  position: absolute;
  left: 126px;
  right: 0px;
  top: 0px;
  height: 40px;
  line-height: 20px;
  font-size: 15px;
  color: #000000;
  overflow: hidden;
}
.section8 .content .items .item .time{
  position: absolute;
  left: 126px;
  top: 50px;
  height: 22px;
  line-height: 22px;
  font-size: 13px;
  color: #999999;
}
.section8 .content .items .item .time img{
  width: 10px;
  height: 10px;
}
.section9{
  height: 45px;
  background-color: #FFFFFF;
}
.section10{
  position: relative;
  height: 145px;
  background-color: #FFFFFF;
}
.section10 .slideList{
  margin-top: 10px;
}
.slideList .slide{
  position: relative;
  width: 100%;
  height: 40px;

}
.slideList .slide .box{
  position: absolute;
  top: 16px;
  left: 15px;
  height: 8px;
  width: 8px;
  background-color: #c9c9c9;
}
.slideList .slide .title{
  position: absolute;
  top: 0px;
  left: 35px;
  right: 15px;
  height: 40px;
  line-height: 40px;
  color: #333333;
  font-size: 14px;
  word-wrap:break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/view/enterprise-list.vue